//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import tabbox from '@/components/ui/tabbox';
import loadmore from '@/components/ui/loadmore';

import mainMenuTab from "@/components/mainMenuTab";
import goodsList from "@/components/goodsList";

export default {
    components: {mainMenuTab,goodsList,cardbox,navbar,tabbox,loadmore},
    data(){
        return {
            tabData: [
                {label:'商品',value: 1, type: 'goods', active: true},
                {label:'店铺',value: 0, type: 'store', active: false},
            ],
            listData: {
                total: 0,
                page: 1,
                size: 50,
                data: []
            },
            currentTab: {label:'商品',value: 1, type: 'goods', active: true},
        }
    },
    methods:{

        // 切换tab
        changeTab(item,index){
            this.currentTab = item;
            this.queryList();
        },

        // 查询列表
        queryList(){

            const opts = {
                url: api.myFavorite,
                data: {
                    type: this.currentTab.type
                },
                type: 'get'
            }
            common.query(opts).then(res=>{

                this.listData = res.data;

            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

        // 查询列表
        cancelFavorite(item,index){

            const _this = this;
            const opts = {
                url: api.favoriteDel,
                data: {
                    type: item.type,
                    id: item.item_id,
                },
                type: 'delete'
            }

            this.$vux.confirm.show({
                title: '取消收藏',
                content: item.data.goods_name,
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.$vux.toast.text("操作成功。",'top');
                        _this.queryList();
                    },res=>{
                        _this.$vux.toast.text(res.message);
                    })
                }
            })
        },


    },
    mounted(){

        this.queryList();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/favorite.vue